module.exports = __webpack_public_path__ + "assets/e97603db09e41262edee84ee9b6c53e0.mp3";